<template>
  <div>

    <main class="home">
      <div class="content">

        <div class="form">
          <div class="field">
            <label for="name">Name</label>
            <input v-validate="'required'" v-model="auth.name" type="text" name="name" id="name" placeholder="Your name">
            <span>{{ errors.first('name') }}</span>
          </div>
          <div class="field">
            <label for="location">City/Town</label>
            <select v-model="auth.location" name="location" id="location">
              <option disabled value="">Your city/town</option>
              <option value="Northland">Northland</option>
              <option value="Auckland">Auckland</option>
              <option value="Waikato">Waikato</option>
              <option value="Bay of Plenty">Bay of Plenty</option>
              <option value="Gisborne">Gisborne</option>
              <option value="Hawkes Bay">Hawkes Bay</option>
              <option value="Manawatu - Wanganui">Manawatu - Wanganui</option>
              <option value="Taranaki">Taranaki</option>
              <option value="Wellington">Wellington</option>
              <option value="Tasman">Tasman</option>
              <option value="Nelson">Nelson</option>
              <option value="Marlborough">Marlborough</option>
              <option value="West Coast">West Coast</option>
              <option value="Canterbury">Canterbury</option>
              <option value="Otago">Otago</option>
              <option value="Southland">Southland</option>
            </select>
            <span>{{ errors.first('location') }}</span>
          </div>
          <div class="field">
            <label for="email">Email</label>
            <input v-validate="'required|email'" v-model="auth.email" type="email" name="email" id="email" placeholder="Your email address">
            <span>{{ errors.first('email') }}</span>
          </div>
          <div class="field">
            <label for="password">Password</label>
            <input v-validate="'required'" v-model="auth.password" type="password" name="password" id="password" placeholder="Your password">
            <span>{{ errors.first('password') }}</span>
          </div>
          <div class="field checkbox">
            <label for="offers">I wish to receive special offers, events and news from Jeep New Zealand</label>
            <input v-model="auth.offer" type="checkbox" name="offer" id="offer">
          </div>
          <div class="field">
            <button class="button" @click="submit">Sign in to continue</button>
            <router-link to="/" class="button grey">Back</router-link>
          </div>
          <p class="http-error" v-if="error" >
            <i v-for="(err, index) in error" :key="index">{{ err[0] }}</i>
          </p>
        </div>

      </div>
    </main>
    <Footer></Footer>

  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import Footer from '@/components/Footer'

export default {
  name: 'register',
  components: {
    Logo, Footer
  },
  data () {
    return {
      auth: {
        name: null,
        email: null,
        location: null,
        offer: false
      },
      error: null
    }
  },
  mounted () {
  },
  methods: {
    submit () {
      this.$validator.validate().then(result => {
        if (!result) {
          // do stuff if not valid.
        } else {
          this.submitAxios()
        }
      })
    },
    submitAxios () {
      this.$http.register(this.auth)
        .then((res) => {
          this.$store.state.isLoading = true
          console.log('then login', res)
          if (res.status !== undefined) {
            console.log('logged-in')
            this.$router.push({ path: 'home' })
          } else {
            console.log('else', res)
            this.error = res
          }
        })
        .then((res) => {
          this.$store.state.isLoading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  body {
    background-color: #F0F0F0;
  }
  main.home {
    padding: 60px 0 105px;

    .form {
      padding: 0 6%;
    }
  }
</style>
